import { Injectable } from "@angular/core";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { HeaderService } from "./header.service";
import { StoreHelper } from "../helpers/store.helper";
import { Router } from "@angular/router";

@Injectable()
export class HttpService {

  private headers: HttpHeaders;

  private baseUrl = ''


  constructor(
    private http: HttpClient,
    private headerService: HeaderService,
    private router: Router
  ) {
    this.baseUrl = this.headerService.getBaseUrl();
  }

  async getText( urlComponent, params ){
    this.headerService.createAuthorizationHeader()

    const promise = new Promise( (resolve,reject) => {
      
      this.headers = this.headerService.getHeaders()
      let url = this.baseUrl + urlComponent;
      
      this.http.post( url, params, { headers: this.headers, responseType: 'text', withCredentials: true } )
      .subscribe( (result) => {
        resolve(result)
      }, (err) => {
        if( err.status == 402 ){
          // redirect
          resolve([])
        }
        reject( err )
      })
    })
    return promise
  }

  async getBlob( urlComponent ){
    this.headerService.createAuthorizationHeader()

    const promise = new Promise( (resolve,reject) => {

      this.get( urlComponent, true ).subscribe( (result) => {
        resolve(result)
      }, (err) => {
        if( err.status == 402 ){
          // redirect
          resolve([])
        }
        reject( err )
      })
    })
    return promise
  }


  async getAsync( urlComponent ){
    this.headerService.createAuthorizationHeader()

    const promise = new Promise( (resolve,reject) => {

      this.get( urlComponent ).subscribe( (result) => {
        try{
          resolve(result)
        }
        catch( e ){
          reject(e)
        }
      }, (err) => {
        if( err.status == 402 ){
          // redirect
          this.logout()
          resolve([])
        }
        reject( err )
      })
    })
    return promise
  }

  async postAsync( urlComponent, data ){
    this.headerService.createAuthorizationHeader()

    const promise = new Promise( (resolve, reject) => {

      this.post( urlComponent, data )
      .subscribe(
        result => {
          try{
            resolve(result)
          }catch( e ){
            reject(e)
          }

        },
        err => {
          if( err.status == 402 ){
            // redirect
            this.logout()
            resolve([])
          }

          reject(err)
        })

    })
    return promise
  }

  async postBlob( urlComponent, data ){
    this.headerService.createAuthorizationHeader()

    const promise = new Promise( (resolve, reject) => {
      this.headers = this.headerService.getHeaders()
      let url = this.baseUrl + urlComponent;

      this.http.post( url, data, { headers: this.headers, responseType: 'blob', withCredentials: true })
      .subscribe(
        result => {
          try{
            resolve(result)
          }catch( e ){
            reject(e)
          }

        },
        err => {
          if( err.status == 402 ){
            // redirect
            this.logout()
            resolve([])
          }

          reject(err)
        })

    })
    return promise
  }

  logout( ){
    StoreHelper.clearUser()
    this.router.navigate(['/signin'])
  }

  getBaseUrl( ){
    return this.headerService.getBaseUrl()
  }

  get( urlComponent, blob = false ){
    this.headers = this.headerService.getHeaders()

    let url = this.baseUrl + urlComponent;
    
    // HttpClient defaults to JSON, so for JSON we don't need to specify responseType
    // But for Blob we do.
    if( blob ){
        return this.http.get(url, { headers: this.headers, responseType: 'blob', withCredentials: true })
    }
    
    return this.http.get(url, { headers: this.headers, withCredentials: true })
  }

  post( urlComponent, data ){
    this.headers = this.headerService.getHeaders()

    let url = this.baseUrl + urlComponent;

    return  this.http.post( url, data, { headers: this.headers, withCredentials: true })
  }



}
